/* global activeModal:true */

/**
 * profile_nav handles the interactivity for the about me portion of the my soul tab
 */
SC.aboutMe = (function () {
  // buttons
  var backToPersonalButton = null; // back to personal info on payment edit form
  var cancelButtons = null; // main cancel button
  var cancelDeleteButton = null; // cancel button on delete modal
  var cancelPaymentEditButton = null; // cancel button on payment edit
  var deleteAccountButton = null;
  var deleteCardButton = null; // 'x' to delete card
  var deleteFormButton = null; // delete butotn on delete modal account
  var manageCardsButton = null;
  var backToPaymentInfoButton = null;
  var editPasswordButtons = null; // 'password fields'
  var handleBarsCheckBox = null;
  // TODO: not 100% sure if deleting this unused variable is safe
  // eslint-disable-next-line no-unused-vars
  var headerEditButton = null; // birthday/gender edit button
  var mainEditButtons = null; // main edit button at bottom of page
  var saveButton = null; // main save button at bottom of page
  var savePaymentButton = null; // save button on payment form

  // dom elements
  var aboutMeContainer = null; // main about me container
  var aboutMeInputs = null;  // inputs only for the personal form
  var aboutMeForm = null; // about me form
  var deleteAccountModal = null; // modal container for account deletion
  var modal = null; // main modal container
  var paymentForm = null; // payment edit form
  var manageCardsSection = null;
  var paymentInputs = null; // inputs only for the payment form;
  var sameAsBilling = null; // checkbox for same as billing
  var selects = null; // all select elements to build custom dropdowns.
  // TODO: not 100% sure if deleting this unused variable is safe
  // eslint-disable-next-line no-unused-vars
  var inputs = null; // all input elements to build.
  var manageCCModalContainer = null;
  var ccConfirmModal = null; // Modal for payment method default/delete action
  // Manage Credit cards section
  var ccModalIcon = null; // Modal icon container
  var ccModalMessage = null; // Modal message 
  var ccConfirmBtn = null; // Confirmation button
  var ccCancelBtn = null; // Cancel button
  var paymentCards = null;
  // flags
  var isModalActive = false;
  var formOpenedFromManageCards = false; // tracks whether payment form was opened from manage cards, to determine cancel destination

  function init() {
    aboutMeContainer = document.getElementById('profile-aboutme');

    if (!aboutMeContainer) {
      return;
    }

    aboutMeForm = document.getElementById('aboutme-personal-form');
    aboutMeInputs = aboutMeForm.getElementsByTagName('input');
    backToPersonalButton = document.getElementById('back-to-personal');
    cancelButtons = document.getElementsByClassName('aboutme__cancel');
    cancelPaymentEditButton = document.getElementById('payment-cancel-edit');
    deleteAccountButton = document.getElementById('handle-aboutme-delete');
    deleteCardButton = document.getElementById('payment-delete-card');
    deleteAccountModal = document.getElementById('delete-account-modal');
    manageCardsButton = document.getElementById('js-manage-cards');
    backToPaymentInfoButton = document.getElementById('js-back-to-personal');
    editPasswordButtons = document.querySelectorAll('.personal__password__option input');
    handleBarsCheckBox = document.getElementById('frm-bike_extended_handlebars');
    headerEditButton = document.getElementById('edit-header-aboutme');
    inputs = aboutMeContainer.getElementsByTagName('input');
    mainEditButtons = document.getElementsByClassName('aboutme__edit');
    modal = document.getElementById('aboutme-modal');
    cancelDeleteButton = modal.querySelector('#modal-delete-cancel-button');
    deleteFormButton = modal.querySelector('#modal-delete-delete-button');
    paymentForm = document.getElementById('aboutme-payment-form');
    manageCardsSection = document.querySelector('.manage_cards__section-container');
    paymentInputs = paymentForm.getElementsByTagName('input');
    sameAsBilling = document.getElementById('shipping-same-as-billing');
    saveButton = document.getElementById('aboutme-save-edit');
    savePaymentButton = document.getElementById('payment-save-edit');
    selects = aboutMeContainer.getElementsByTagName('select');
    manageCCModalContainer = document.getElementById('manage-cc-modal');
    paymentCards = document.querySelectorAll('.js-payment-profiles');

    if (manageCCModalContainer) {
      ccConfirmModal = manageCCModalContainer.querySelector('#cc-confirm-modal');
      ccModalIcon = ccConfirmModal.querySelector('.cc-confirm-modal__icon');
      ccModalMessage = ccConfirmModal.querySelector('.cc-confirm-modal__message');
      ccConfirmBtn = ccConfirmModal.querySelector('[data-modal-action="confirm"]');
      ccCancelBtn = ccConfirmModal.querySelector('[data-modal-action="cancel"]');
    }
    // Remove redirectResult query param from URL after Adyen redirect so it doesn't affect subsequent actions on this page.
    if (new URLSearchParams(window.location.search).has('redirectResult')) {
      history.replaceState(null, '', window.location.pathname);
    }

    bindListeners();
    buildCustomDropDowns();
    updateCheckBoxes();
    updateDates();
  }

  /**
   * bindListeners binds all the event listeners for toggling the nav and handling resize.
   * @returns {void}
   */
  function bindListeners() {
    aboutMeForm.addEventListener('submit', saveEdits);
    backToPersonalButton.addEventListener('click', hidePaymentForm);
    cancelDeleteButton.addEventListener('click', closeAndSaveModal);
    cancelPaymentEditButton.addEventListener('click', hidePaymentForm);
    deleteAccountButton.addEventListener('click', showModal);
    deleteFormButton.addEventListener('click', closeAndSaveModal);
    backToPaymentInfoButton.addEventListener('click', hideManageCardsSection);
    handleBarsCheckBox.addEventListener('change', handleCheckbox);
    sameAsBilling.addEventListener('change', updateShipping);
    paymentForm.addEventListener('submit', savePaymentEdits);
    paymentCards.forEach(card => {
      card.addEventListener('click', handleCardClick);
    });
    if (ccCancelBtn) {
      ccCancelBtn.addEventListener('click', closeCCModal);
    }

    if(manageCardsButton) {
      manageCardsButton.addEventListener('click', showManageCardsSection);
    }

    for (var cancelButtonIndex = 0; cancelButtonIndex < cancelButtons.length; cancelButtonIndex++) {
      cancelButtons[cancelButtonIndex].addEventListener('click', cancelEdits);
    }

    for (var editButtonIndex = 0; editButtonIndex < mainEditButtons.length; editButtonIndex++) {
      mainEditButtons[editButtonIndex].addEventListener('click', handleEdit);
    }

    if (deleteCardButton) {
      deleteCardButton.addEventListener('click', deleteCard);
    }

    var i;
    for (i = 0; i < aboutMeInputs.length; i++) {
      aboutMeInputs[i].addEventListener('keydown', submitOnEnter);
    }

    for (i = 0; i < paymentInputs.length; i++) {
      paymentInputs[i].addEventListener('keydown', submitOnEnter);
    }

    for (i = 0; i < editPasswordButtons.length; i++) {
      editPasswordButtons[i].addEventListener('click', enablePasswordFields);
    }

    // Add a credit card button(On Pages: About me, Manage cards)
    aboutMeContainer.querySelectorAll('button.js-add-credit-card').forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        // Adding a new card — clear any previously tracked edit target
        const profileToEditInput = paymentForm.querySelector('#payment-profile-to-edit');
        if (profileToEditInput) profileToEditInput.value = '';

        // When 'Add another card' clicked hide manage cards section
        if (btn.closest('.manage_cards__section-container')) {
          formOpenedFromManageCards = true;
          hideManageCardsSection();
        } else {
          formOpenedFromManageCards = false;
        }

        showPaymentForm();
      });
    });

    aboutMeContainer.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-action]');

      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const { action, creditCardId, ccNumber } = btn.dataset;
      openCCModal({ action, creditCardId, ccNumber });
    });

    if (ccConfirmBtn) {
      ccConfirmBtn.addEventListener('click', function () {
        const { mode, creditCardId } = ccConfirmModal.dataset;
        toggleThrobber(true);
        if (mode === 'delete') {
          deleteCreditCard(creditCardId);
        } else if (mode === 'make-default') {
          makeDefaultCreditCard(creditCardId);
        }
      });
    }
  }

  /**
   * buildCustomDropDowns finds all select elements and creates custom dropdowns that can be
   * styled with css or use a passed in array.
   *
   * @param {array} mySelects array of select html tags to build
   * @returns {void}
   */
  function buildCustomDropDowns(mySelects) {
    // build only the passed in select or all of them
    var selectsToBuild = mySelects || selects;

    for (var i = 0; i < selectsToBuild.length; i++) {
      var select = selectsToBuild[i];
      var name = select.getAttribute('name') || '';
      var sectionType = select.getAttribute('data-section-type') || '';
      var selected = select.options[select.selectedIndex];
      var wrapper = document.createElement('div'); // main wrapper for everything part of the select
      var defaultButton = document.createElement('button'); // mimics the defautl option of a select
      var optionsWrapper = document.createElement('div'); // wrapper for all options

      // setup the classes
      wrapper.classList.add('custom__select');
      select.classList.add('custom__select--hidden');
      defaultButton.classList.add('custom__select--styled');
      defaultButton.setAttribute('type', 'button');

      // wrap the select in a div
      select.parentNode.insertBefore(wrapper, select);
      wrapper.appendChild(select);

      // insert a button that mimics the default option
      select.parentNode.insertBefore(defaultButton, select.nextSibling);

      if (selected) {
        defaultButton.innerHTML = selected.innerHTML;
      } else {
        defaultButton.innerHTML = select.children[0].innerHTML;
      }

      // create a wrapper for the clone options and insert after the default button
      optionsWrapper.classList.add('custom__select__options');
      defaultButton.parentNode.insertBefore(optionsWrapper, defaultButton.nextSibling);

      // build out the cloned options and append them to the options wrapper
      // exclude the default option
      for (var j = 0; j < select.children.length; j++) {
        var option = document.createElement('button');
        option.classList.add('custom__select__item');
        option.setAttribute('data-group', name);
        option.setAttribute('data-section-type', sectionType);
        option.setAttribute('data-value', select.children[j].value);
        option.setAttribute('type', 'button');

        // if we have a default value already selected set the text
        // otherwise use the default from the original select.
        if (j === 0 && selected) {
          option.innerHTML = selected.innerHTML;
        } else {
          option.innerHTML = select.children[j].innerHTML;
        }

        // for the default option, hide it from screen readers and set a specific class
        if (j === 0) {
          option.setAttribute('aria-visibility', 'hidden');
          option.classList.add('custom__select__item-default');
        }

        optionsWrapper.appendChild(option);

        // handle the click on each option
        option.addEventListener('click', handleOptionClick);
      }

      // handle the click on the default option
      defaultButton.addEventListener('click', handleSelectClick);
    }

    document.addEventListener('click', closeDropDowns);
  }

  /**
   * closeDropDowns closes all open dropdowns on a document click
   *
   * @returns {void}
   */
  function closeDropDowns() {
    var activeSelect = aboutMeContainer.querySelector('.custom__select--styled--active');

    if (!activeSelect) {
      return;
    }

    var activeOptions = activeSelect.nextElementSibling;

    activeSelect.classList.remove('custom__select--styled--active');
    activeOptions.style.display = 'none';
  }

  /**
   * handleSelectClick toggles the active state of a dropdown and hides/shows the correct options
   *
   * @param {object} e the click event on the default option
   * @returns {void}
   */
  function handleSelectClick(e) {
    e.stopPropagation();

    var target = e.currentTarget;
    var activeButton = aboutMeContainer.querySelector('.custom__select--styled--active');
    var optionsWrapper = target.nextElementSibling;

    // if an active button exists and it's not the current target close it and hide its options
    if (activeButton && activeButton !== target) {
      activeButton.classList.remove('custom__select--styled--active');
      activeButton.nextElementSibling.style.display = 'none';
    }

    // if we don't have an active or the current is active, toggle its state and options
    target.classList.toggle('custom__select--styled--active');
    optionsWrapper.style.display = optionsWrapper.style.display === 'block' ? 'none' : 'block';

    // if we just opened the wrapper, shift focus there
    if (optionsWrapper.style.display === 'block') {
      optionsWrapper.focus();
    }
  }

  /**
   * updateStateOptions rebuilds the slect dropdown with new states based on
   * the country selected
   *
   * @param {object} target the dom node clicked on
   * @returns {void}
   */
  function updateStateOptions(target) {
    var state;
    var country = target.getAttribute('data-value');
    var sectionType = target.getAttribute('data-section-type') || '';
    var stateOptions = soulcycle.addressStateOptions[country];
    var zip = document.getElementById('frm-' + sectionType + '_zip');
    var initialSelect = document.getElementById('frm-' + sectionType + '_state');

    initialSelect.innerHTML = '';

    for (state in stateOptions) {
      if (Object.prototype.hasOwnProperty.call(stateOptions, state)) {
        var option = document.createElement('option');

        option.value = state;
        option.text = country !== 'GB' ? state : stateOptions[state];

        initialSelect.appendChild(option);
      }
    }

    // reset the already built dropdown to empty and move the select back to the parent container
    var parentContainer = initialSelect.parentNode.parentNode;

    parentContainer.appendChild(initialSelect);
    parentContainer.removeChild(parentContainer.querySelector('.custom__select'));

    // update zip/postal code
    zip.previousElementSibling.innerHTML = country === 'US' ? 'Zip' : 'Postal Code';
    zip.innerHTL = '';

    buildCustomDropDowns([initialSelect]);
  }

  /**
   * updateCheckBoxes sets the initial value of the extended handlebars checkbox
   * @returns {void}
   */
  function updateCheckBoxes() {
    var inputsChecked = document.querySelectorAll('input:checked');

    for (var i = 0; i < inputsChecked.length; i++) {
      var input = inputsChecked[i];
      setCheckBoxValues(input);
    }
  }

  /**
   * updateDates updates the day options based on the month and year.
   * @returns {void}
   */
  function updateDates() {
    var currentYear = moment().year();
    var currentMonth = moment().month() + 1; // 0 based array we need the actual month index
    var currentDay = moment().date();
    var month = document.getElementById('frm-birthday_month');
    var day = document.getElementById('frm-birthday_day');
    var year = document.getElementById('frm-birthday_year');
    var selectedMonth = parseInt(month.options[month.selectedIndex].value, 0);
    var selectedYear = parseInt(year.options[year.selectedIndex].value, 0);
    var totalDays = 31;
    var lastDay = day.options.length - 1;

    // Check for the correct amount of days in the selected month and year.
    // Includes leap year checks.
    totalDays = getDaysInMonth(selectedMonth, selectedYear);

    // If the user selected the current year and the current month is not equal to the amount
    // of month options, remove all future months and days.
    if (selectedYear === currentYear && currentMonth !== month.options.length - 1) {
      removeDropdownOptions(12, currentMonth, month.id);
      totalDays = currentDay;

    // if it's not the current year and the months options are not full rebuild
    // length === 13 (12 months + one default option)
    } else if ( month.options.length !== 13 && selectedYear !== currentYear) {
      var lastMonth = parseInt(month.options[month.options.length - 1].value, 0);
      addDropdownOptions(lastMonth, 12, month.id);
    }

    // if the amount of options currently is less than the total days in the month
    // then we need to add options, else remove them
    if (lastDay < totalDays) {
      addDropdownOptions(lastDay, totalDays, day.id);
    } else {
      removeDropdownOptions(lastDay, totalDays, day.id);
    }

    resetDropDown(day);
    resetDropDown(month);
    buildCustomDropDowns([day, month]);
  }

  /**
   * This disables the password fields readonly attribute
   * @returns {void}
   */
  function disablePasswordFields() {
    for (var i = 0; i < editPasswordButtons.length; i++) {
      editPasswordButtons[i].readOnly = true;
      editPasswordButtons[i].value = '';
    }
  }

  /**
   * Enable password fields on click if they are readonly
   * Enabled Edit mode
   * @returns {void}
   */
  function enablePasswordFields() {
    for (var i = 0; i < editPasswordButtons.length; i++) {
      if (editPasswordButtons[i].readOnly) {
        editPasswordButtons[i].readOnly = false;
        handleEdit();

        // Focus on the edit password field
        editPasswordButtons[0].focus();
      }
    }
  }

  /**
   * resetDropDown resets the dropdowns to their original dom states with potentially new options
   * before they were custom built so that we can rebuild if necessary with any new options
   *
   * @param {object} dropDown the dropdown element to append
   * @returns {void}
   */
  function resetDropDown(dropDown) {
    var parentContainer = dropDown.parentNode.parentNode;

    parentContainer.appendChild(dropDown);
    parentContainer.removeChild(parentContainer.querySelector('.custom__select'));
  }

  /**
   * addDropdowns adds options to a dropdown
   *
   * @param {int} initialIndex index to start adding options from
   * @param {int} lastIndex index to stop adding options
   * @param {string} id the id of the dropdown to add options to
   * @returns {void}
   */
  function addDropdownOptions(initialIndex, lastIndex, id) {
    var locale = moment().locale('en');
    var months = locale.localeData().monthsShort();
    var dropDown = document.getElementById(id);
    var stringValue = '';

    for (var i = initialIndex + 1; i <= lastIndex; ++i) {
      var option = document.createElement('option');

      stringValue = i < 10 ? '0' + i : i;
      option.value = stringValue;
      option.innerHTML = dropDown.name === 'birthday_day' ? stringValue : months[i - 1];
      dropDown.appendChild(option);
    }
  }

  /**
   * removeDropdownOptions removes options from a dropdown
   *
   * @param {int} initialIndex the index to start removing from
   * @param {int} lastIndex the index to stop removing at
   * @param {string} id the id of the dropdown to remove options from
   * @returns {void}
   */
  function removeDropdownOptions(initialIndex, lastIndex, id) {
    var dropDown = document.getElementById(id);
    var stringValue = '';

    for (var i = initialIndex; i > lastIndex; i--) {
      stringValue = i < 10 ? '0' + i : i;
      dropDown.removeChild(dropDown.querySelector('option[value="' + stringValue + ''));
    }
  }

  /**
   * getDaysInMonth does a simple check for the total days in the month/year requested.
   *
   * @param {int} month month to check
   * @param {int} _year year to check
   * @return {int} total days in month
   */
  function getDaysInMonth(month, _year) {
    var year = _year || '2016';

    return moment(year + '-' + month, 'YYYY-MM').daysInMonth();
  }

  /**
   * handleCheckBox sets the value attribute on click/unclick of a checkbox
   *
   * @param {object} e the click event on the checkbox
   * @returns {void}
   */
  function handleCheckbox(e) {
    setCheckBoxValues(e.currentTarget);
  }

  /**
   * setCheckboxValues sets the value attribute on an checkbox input
   *
   * @param {object} input dom node (input) to update
   * @returns {void}
   */
  function setCheckBoxValues(input) {
    if (input.checked) {
      input.setAttribute('value', 1);
    } else {
      input.setAttribute('value', 0);
    }
  }

  /**
   * handleOptionClick sets the selected values on the original select based on the
   * option clicked on
   *
   * @param {object} e the click event on an options
   * @returns {void}
   */
  function handleOptionClick(e) {
    e.stopPropagation();
    var target = e.currentTarget;
    var dataGroup = target.getAttribute('data-group');

    // traverse up one parent to get to the wrapper and get the previous siblings for the default button & select
    var optionsWrapper = target.parentNode;
    var defaultPlaceholder = optionsWrapper.children[0];
    var defaultButton = optionsWrapper.previousElementSibling;
    var select = defaultButton.previousElementSibling;

    // set the default button's text and the default placeholder's text to the select option text and close it
    defaultButton.innerHTML = target.innerHTML;
    defaultPlaceholder.innerHTML = target.innerHTML;
    defaultButton.classList.remove('custom__select--styled--active');
    optionsWrapper.style.display = 'none';

    // set the selected value on the original select
    var originalOption = select.querySelector('option[value="' + target.getAttribute('data-value') + '"]');
    originalOption.selected = true;

    if (dataGroup === 'billing_country' || dataGroup === 'shipping_country') {
      updateStateOptions(target);
    }

    if (dataGroup === 'birthday_month' || dataGroup === 'birthday_year') {
      updateDates();
    }
  }

  /**
   * deleteCards makes an ajax request to /checkout/credit-card to delete a user's credit card.
   *
   * @param {object} e click event on the delete card button
   * @returns {void}
   */
  function deleteCard(e) {
    e.preventDefault();

    confirmation(undefined, 'Are you sure you want to delete this payment method?', {
      ok: {
        label: 'Yes',
        callback: function (e) {
          if (e) {
            e.preventDefault();
          }

          toggleThrobber(true);

          $.ajax({
            url: '/checkout/credit-card/',
            type: 'DELETE',
            dataType: 'json',
            success: function () {
              window.location.href = '/profile/my_soul/about_me/';
            },
            error: function () {
              toggleThrobber(false);
              confirmation(false, 'We experienced an error removing this card.  Try that again!');
            }
          });
        }
      },
      cancel: {
        label: 'No',
        callback: closeConfirmation
      }
    });
  }

  /**
   * cancelEdits removes the edit-mode class from the aboutme container
   * and restores any changes that were made.
   * @returns {void}
   */
  function cancelEdits() {
    aboutMeContainer.classList.remove('edit-mode');
    disablePasswordFields();
  }

  /**
   * handleEdit adds the edit-mode class to the aboutme container
   * and builds custom dropdowns, updates the checkboexes and dates.
   * @returns {void}
   */
  function handleEdit() {
    // setup the edit mode.
    aboutMeContainer.classList.add('edit-mode');

    // shift focus to the first editable element
    var birthdayMonth = document.querySelector('.personal__option__birthday button');

    birthdayMonth.focus();
  }

  /**
   * showPaymentForm shows the billing/shipping edit form and hides
   * the personal form
   * @returns {void}
   */
  function showPaymentForm() {
    window.scrollTo(0, 0);

    paymentForm.classList.add('aboutme__payment__form--active');
    paymentForm.classList.add('edit-mode');
    aboutMeForm.classList.remove('aboutme__personal__form--active');
    manageCardsSection.classList.remove('edit-mode');
  }

  /**
   * hidePaymentForm hides the billing/shipping edit form and displays
   * the personal form
   * @returns {void}
   */
  function hidePaymentForm() {
    paymentForm.classList.remove('aboutme__payment__form--active');
    paymentForm.classList.remove('edit-mode');

    // Reset payment method form
    ['billing_first_name', 'billing_last_name', 'billing_address_1', 'billing_address_2', 'billing_city', 'billing_state', 'billing_zip'].forEach(name => {
      const input = paymentForm.querySelector(`[name="${name}"]`);
      if (input) input.value = '';
    });

    const profileToEditInput = paymentForm.querySelector('#payment-profile-to-edit');
    if (profileToEditInput) profileToEditInput.value = '';

    if (formOpenedFromManageCards) {
      showManageCardsSection();
    } else {
      aboutMeForm.classList.add('aboutme__personal__form--active');
    }
  }

  /**
   * showManageCardsSection shows riders manage cards section
   * (make default & delete) and hides the personal form
   * @returns {void}
   */
  function showManageCardsSection() {
    window.scrollTo(0, 0);
    manageCardsSection.classList.add('edit-mode');
    aboutMeForm.classList.remove('aboutme__personal__form--active');
  }

  /**
   * hideManageCardsSection hides riders manage cards section
   * shows personal form
   * @returns {void}
   */
  function hideManageCardsSection() {
    manageCardsSection.classList.remove('edit-mode');
    aboutMeForm.classList.add('aboutme__personal__form--active');
  }

  function deleteCreditCard(creditCardId) {
    $.ajax({
      url: '/checkout/credit-card/?creditCardId=' + creditCardId,
      type: 'DELETE',
      dataType: 'json',
      success() {
        confirmation(true, 'Card deleted successfully.');
        removeCardFromDOM(creditCardId);
        closeCCModal();
      },
      error() {
        confirmation(false, 'Error deleting card. Try again.');
        closeCCModal();
      }
    });
  }

  function makeDefaultCreditCard(creditCardId) {
    $.ajax({
      url: '/update-default-payment-profile/' + creditCardId + '/',
      type: 'POST',
      dataType: 'json',
      data: { csrf_token: window.soulcycle.noncePool.pop() },
      success() {
        confirmation(true, 'This card is now your default payment method.');
        promoteCardToDefault(creditCardId);
        closeCCModal();
      },
      error() {
        confirmation(false, 'Error updating default card. Try again.');
        closeCCModal();
      }
    });
  }

  function removeCardFromDOM(creditCardId) {
    const manageContainer = document.querySelector('.manage_cards__section-container');

    if (manageContainer) {
      const manageCardEl = manageContainer.querySelector(`[data-credit-card-id="${creditCardId}"]`);

      if (manageCardEl) {
        const row = manageCardEl.closest('.manage_cards__row');
        const section = row.closest('[data-section]');

        row.remove();

        if (section && !section.querySelector('.manage_cards__row')) {
          section.remove();
        }
      }
    }

    const billingContainer = document.querySelector('.payment-info-cards-container');

    if (billingContainer) {
      const billingCardEl = billingContainer.querySelector(`[data-credit-card-id="${creditCardId}"]`);

      if (billingCardEl) {
        const section = billingCardEl.closest('[data-section]');

        billingCardEl.remove();

        if (section && !section.querySelector('.payment-info-cards__card')) {
          section.remove();
        }
      }
    }
  }

  function promoteCardToDefault(creditCardId) {
    updateManageCardsForPromotion(creditCardId);
    updateBillingCardsForPromotion(creditCardId);
  }

  function updateManageCardsForPromotion(creditCardId) {
    const container = document.querySelector('.manage_cards__section-container');

    if (!container) return;

    const otherSection = container.querySelector('[data-section="other"]');

    if (!otherSection) return;

    const promotedCardEl = otherSection.querySelector(`[data-credit-card-id="${creditCardId}"]`);

    if (!promotedCardEl) return;

    const promotedRow = promotedCardEl.closest('.manage_cards__row');

    promotedRow.querySelector('.manage_cards__set-default')?.remove();

    let defaultSection = container.querySelector('[data-section="default"]');

    if (!defaultSection) {
      defaultSection = document.createElement('div');
      defaultSection.className = 'manage_cards__section payment-info-cards__section';
      defaultSection.dataset.section = 'default';
      defaultSection.innerHTML = '<h4>Default Card</h4><div class="my-cards"></div>';
      container.insertBefore(defaultSection, otherSection);
    }

    const oldDefaultRow = defaultSection.querySelector('.manage_cards__row');

    if (oldDefaultRow) {
      const oldCardEl = oldDefaultRow.querySelector('[data-credit-card-id]');
      const oldCreditCardId = oldCardEl?.dataset.creditCardId ?? '';
      const oldCcLast4 = oldDefaultRow.querySelector('.cc-number')?.textContent.trim().slice(-4) ?? '';
      const actionsDiv = oldDefaultRow.querySelector('.manage_cards__actions');
      const setDefaultBtn = document.createElement('button');

      setDefaultBtn.className = 'manage_cards__set-default';
      setDefaultBtn.dataset.action = 'make-default';
      setDefaultBtn.dataset.creditCardId = oldCreditCardId;
      setDefaultBtn.dataset.ccNumber = oldCcLast4;
      setDefaultBtn.textContent = 'Set as default';
      actionsDiv.appendChild(setDefaultBtn);

      otherSection.querySelector('.my-cards').appendChild(oldDefaultRow);
    }

    defaultSection.querySelector('.my-cards').appendChild(promotedRow);

    if (!otherSection.querySelector('.manage_cards__row')) {
      otherSection.remove();
    }
  }

  function updateBillingCardsForPromotion(creditCardId) {
    const container = document.querySelector('.payment-info-cards-container');

    if (!container) return;

    const otherSection = container.querySelector('[data-section="other"]');

    if (!otherSection) return;

    const promotedCardEl = otherSection.querySelector(`[data-credit-card-id="${creditCardId}"]`);

    if (!promotedCardEl) return;

    let defaultSection = container.querySelector('[data-section="default"]');

    if (!defaultSection) {
      defaultSection = document.createElement('div');
      defaultSection.className = 'payment-info-cards__section';
      defaultSection.dataset.section = 'default';
      defaultSection.innerHTML = '<h4>Default Card</h4><div class="my-cards"></div>';
      container.insertBefore(defaultSection, otherSection);
    }

    const oldDefaultCard = defaultSection.querySelector('.payment-info-cards__card');

    if (oldDefaultCard) {
      otherSection.querySelector('.my-cards').appendChild(oldDefaultCard);
    }

    defaultSection.querySelector('.my-cards').appendChild(promotedCardEl);

    if (!otherSection.querySelector('.payment-info-cards__card')) {
      otherSection.remove();
    }
  }

  // Close Manage Credit cards Modal
  function closeCCModal() {
    toggleThrobber(false);
    ccConfirmModal.classList.remove('modal__delete-container--active');
    manageCCModalContainer.style.display = 'none';
    manageCCModalContainer.removeEventListener('click', handleOutsideClick);
  }

  function openCCModal({ action, creditCardId, ccNumber }) {
    document.body.appendChild(manageCCModalContainer);
    manageCCModalContainer.style.display = 'block';
    manageCCModalContainer.focus();
    manageCCModalContainer.addEventListener('click', handleOutsideClick);
  
    ccConfirmModal.classList.add('modal__delete-container--active');
    ccConfirmModal.dataset.mode = action;
    ccConfirmModal.dataset.creditCardId = creditCardId;

    ccModalIcon.classList.remove('trash-icon', 'tick-icon');
    if (action === 'delete') {
      ccModalIcon.classList.add('trash-icon');
      ccModalMessage.innerText =
        `Are you sure you want to delete your payment method ending with ${ccNumber}?`;
      ccConfirmBtn.innerText = 'Yes, delete';
    } else if (action === 'make-default') {
      ccModalIcon.classList.add('tick-icon');
      ccModalMessage.innerText =
        `Are you sure you want to set your payment method ending with ${ccNumber} as default?`;
      ccConfirmBtn.innerText = 'Yes, set as default';
    }
  }
  
  function handleOutsideClick(e) {
    // If clicking directly on backdrop
    if (e.target === manageCCModalContainer) {
      closeCCModal();
    }
  }

  /**
   * submitOnEnter mimicks clicking the save changes button when a user is in an input
   * field and hits enter.
   *
   * @param {object} e keydown event on an input
   * @returns {void}
   */
  function submitOnEnter(e) {
    if (e.key === 'Enter') {
      // programmatically submitting a form creates a redirect so instead
      // trigger a click on the buttons which will submit the form
      if (aboutMeForm.contains(e.currentTarget)) {
        saveButton.click();
      } else {
        savePaymentButton.click();
      }
    }
  }

  /**
   * saveEdits saves all the data that was acted on
   * Maintaining jquery here as there are numerous helper methods
   * that require a jQ object
   *
   * @param {object} e click event on the save changes button
   * @returns {boolean} whether or not to redirect
   */
  function saveEdits(e) {
    e.preventDefault();

    var $form = $('#aboutme-personal-form');
    var firstName = document.getElementById('frm-first_name').value;
    $form.syncMyCsrfTokenWithPool();

    $form.ajaxSubmit({
      dataType: 'json',
      success: function (data) {
        $form.updateCsrfToken();

        if (data.success) {
          confirmation(undefined, 'Your account information has been updated.');
          $form.clearFormErrors();

          updateDisplayValues();
          disablePasswordFields();
          aboutMeContainer.classList.remove('edit-mode');
          // mparticle user identity - add first name attribute
          SC.analytics.mp.userEvent('attribute', firstName, '$FirstName');
        }

        if (data.errors?.length) {
          confirmation(undefined, data.errors.pop() || "Something went wrong.");
        }

        $form.clearFormErrors();
        $form.fieldErrors(data.fieldErrors);

        return false;
      },
      error: function () {
        $form.updateCsrfToken();
      }
    });

    // prevent redirect
    return false;
  }

  /**
   * updateDisplayValues will update the display values for each input/select
   * after a successful ajax submit.
   * @returns {void}
   */
  function updateDisplayValues() {
    var aboutInputs = aboutMeContainer.getElementsByTagName('input');
    selects = aboutMeContainer.getElementsByTagName('select');

    for (var i = 0; i < aboutInputs.length; i++) {
      var input = aboutInputs[i];
      var value = input.value;
      var optionContainer = input.closest('.personal__option');

      if (!optionContainer) {
        continue;
      }

      var valueContainer = optionContainer.querySelector('.personal__value');

      if (valueContainer) {
        if (input.type === 'checkbox') {
          if (input.checked) {
            valueContainer.innerHTML = 'Yes';
          } else {
            valueContainer.innerHTML = 'No';
          }
        } else {
          valueContainer.innerHTML = value;
        }
      }
    }

    for (i = 0; i < selects.length; i++) {
      var select = selects[i];
      var extraText = '';

      if (select.id === 'frm-birthday_month' || select.id === 'frm-birthday_day') {
        extraText = '/';
      }

      optionContainer = select.closest('.personal__option');

      if (!optionContainer) {
        continue;
      }

      valueContainer = optionContainer.querySelector('.personal__value');

      if (valueContainer) {
        if (select.options[select.selectedIndex].value) {
          valueContainer.innerHTML = select.options[select.selectedIndex].value + extraText;
        }
      }
    }
  }

  /**
   * showModal sets the display style to block on the modal
   * and activates the appropriate interior container based on the target id.
   *
   * @param {object} e click event that triggers showing the modal
   * @returns {void}
   */
  function showModal(e) {
    e.preventDefault();
    e.stopPropagation();

    // setup display and focus
    document.body.appendChild(modal);
    modal.style.display = 'block';
    modal.focus();

    switch (e.target.id) {
    case 'handle-aboutme-delete':
      deleteAccountModal.classList.add('modal__delete-container--active');
      deleteAccountModal.setAttribute('data-active-modal', 'true');
      activeModal = 'delete';
      break;
    // No Default
    }

    isModalActive = true;

    document.addEventListener('click', closeModalOutside);
    document.addEventListener('keydown', closeModalOutside);
  }

  /**
   * closeModalOutside handles closing the Modal on clicking outside the modal or by
   * hitting escape
   *
   * @param {object} e event which triggered this function (click/keydown)
   * @returns {void}
   */
  function closeModalOutside(e) {
    e.stopPropagation();

    // act only if the modal is active
    if (!isModalActive) {
      return;
    }

    // Act on either click or escape
    // If click allow only clicks outside the modal
    switch (e.type) {
    case 'keydown' :
      if (e.key === 'Escape') {
        closeAndSaveModal();
      }
      break;
    case 'click' :
      var container = document.querySelector("[data-active-modal='true']");
      var innerContainer = container.children[0];
      if (!innerContainer.contains(e.target) || e.target.classList.contains('modal__delete__cancel', 'modal__delete__submit')) {
        closeAndSaveModal();
      }
      break;
    // No Default
    }
  }

  /**
   * closeAndSaveModal closes the modal and both removes and adds favorite instructor nodes
   * to/from the dom in the main preferences display
   * @returns {void}
   */
  function closeAndSaveModal() {
    modal.style.display = '';
    deleteAccountModal.classList.remove('modal__delete-container--active');
    deleteAccountModal.setAttribute('data-active-modal', 'false');
    deleteAccountButton.focus();
    isModalActive = false;
    activeModal = '';

    document.removeEventListener('click', closeModalOutside);
    document.removeEventListener('keydown', closeModalOutside);
  }

  /**
   * savePayment submits an ajax request to save a users payment/shipping
   * information
   *
   * maintaining jquery here as there are funciton that already depend on it
   * @param {object} e triggered event
   * @returns {boolean} TODO: describe
   */
  function savePaymentEdits(e) {
    e.preventDefault();

    var $soulContainer = $('.soul-container');
    var $form = $('#aboutme-payment-form');
    var $ccNumInput = $form.find('#frm-card_number');
    var cardSaved = $('#cc-last-4').val() ? true : false;

    // Adyen input vars
    var $encryptedCardNumber = $('[name=encryptedCardNumber]');
    var $encryptedExpiryMonth = $('[name=encryptedExpiryMonth]');
    var $encryptedExpiryYear = $('[name=encryptedExpiryYear]');
    var $encryptedSecurityCode = $('[name=encryptedSecurityCode]');
    var $shippingAddressInput = $('form.aboutme__payment__form [name="shipping_address_1"]');
    var $shippingAddress2Input = $('form.aboutme__payment__form [name="shipping_address_2"]');

    if ($soulContainer.hasClass('confirmation-open')) {
      $soulContainer.removeClass('confirmation-open');
    }

    // If Adyen is enabled, the ccNumInput field is removed
    if ($ccNumInput.length > 0) {
      $ccNumInput.val($ccNumInput.val().replace(/[\D]/, ''));
    }

    // Restrict P.O. Boxes from being used in shipping addresses
    if (SC.utils.shippingHasAPOBoxAddress($shippingAddressInput, $shippingAddress2Input)) {
      return false;
    }

    // Validates the secured fields are not empty.
    if (isAdyenActive()) {
      var cardError = null;
      if (!$encryptedSecurityCode.val()) {
        cardError = 'You must enter a CVV code. <span class="visually-hidden">Use your browser\'s modifier key and \'v\' to access the field.</span>';
        $('.input-field[data-cse=encryptedSecurityCode]').addClass('adyen-input-error');
      } else {
        $('.input-field[data-cse=encryptedSecurityCode]').removeClass('adyen-input-error');
      }

      if (!$encryptedExpiryYear.val()) {
        cardError = 'expiration date must be set in the future. <span class="visually-hidden">Use your browser\'s modifier key and \'y\' to access the field.</span>';
        $('.input-field[data-cse=encryptedExpiryYear]').addClass('adyen-input-error');
      } else {
        $('.input-field[data-cse=encryptedExpiryYear]').removeClass('adyen-input-error');
      }

      if (!$encryptedExpiryMonth.val()) {
        cardError = 'expiration date must be set in the future. <span class="visually-hidden">Use your browser\'s modifier key and \'m\' to access the field.</span>';
        $('.input-field[data-cse=encryptedExpiryMonth]').addClass('adyen-input-error');
      } else {
        $('.input-field[data-cse=encryptedExpiryMonth]').removeClass('adyen-input-error');
      }

      if (!$encryptedCardNumber.val()) {
        cardError = 'You must enter a card number. <span class="visually-hidden">Use your browser\'s modifier key and \'n\' to access the field.</span>';
        $('.input-field[data-cse=encryptedCardNumber]').addClass('adyen-input-error');
      } else {
        $('.input-field[data-cse=encryptedCardNumber]').removeClass('adyen-input-error');
      }

      if (cardError !== null) {
        confirmation(undefined, cardError, undefined, 0);
        return false;
      }
    }

    $form.syncMyCsrfTokenWithPool();

    $form.ajaxSubmit({
      dataType: 'json',
      success: function (data) {
        $form.updateCsrfToken();

        if (data.success) {
          // notify user
          confirmation(undefined, data.message);
          $form.clearFormErrors();

          var eventInstance = cardSaved ? 'Existing Credit Card' : 'Add New Credit Card';
          var eventData = {'Location': 'My Account', 'Instance': eventInstance};
          SC.analytics.mp.sendEvent('Add a New Credit Card', 'navigation', eventData, eventInstance);
          window.location.reload();

          return false;
        }

        if (data.hasOwnProperty('fieldErrors')) {
          var keys = Object.keys(data.fieldErrors);
          var message = data.fieldErrors[keys.pop()];
          confirmation(undefined, message);
        }

        $form.clearFormErrors();
        $form.fieldErrors(data.fieldErrors);

        if (!data.success && !data.hasOwnProperty('fieldErrors')) {
          confirmation(undefined, data.message);
        }

        return false;
      },
      error: function (data) {
        if (data.responseText.search('redirect_form') === -1 && data.responseText.search('Adyen redirect') === -1) {
          $form.updateCsrfToken();
          confirmation(undefined, 'Saving payment profile failed');
        } else {
          document.open();
          document.write(data.responseText);
          document.close();
        }
      }
    });

    return false;
  }

  function browserInfo() {
    var colorDepth = window.screen.colorDepth;
    var javaEnabled = window.navigator.javaEnabled();
    var screenHeight = window.screen.height;
    var screenWidth = window.screen.width;
    var userAgent = window.navigator.userAgent;

    // IE <+ 10 supports navigator.browserLanguage instead of navigator.language
    var language = window.navigator.language;
    var d = new Date();
    var timeZoneOffset = d.getTimezoneOffset();

    return {
      colorDepth: colorDepth,
      javaEnabled: javaEnabled,
      language: language,
      screenHeight: screenHeight,
      screenWidth: screenWidth,
      userAgent: userAgent,
      timeZoneOffset: timeZoneOffset
    };
  }

  var browserInfoEl = document.getElementById('browser-info');
  if (browserInfoEl !== null) {
    browserInfoEl.value = JSON.stringify(browserInfo());
  }

  /**
   * updateShipping updates the shipping information with the billing information
   * when a user checks the box
   * @param {object} e triggered event
   * @returns {void}
   */
  function updateShipping(e) {
    var target = e.currentTarget;
    var shippingInfoContainer = document.querySelector('.personal__form__shipping__address');
    var shippingInputs = shippingInfoContainer.getElementsByTagName('input');
    if (!target.checked) {
      for (var i = 0; i < shippingInputs.length; i++) {
        shippingInputs[i].value = '';
      }
      return;
    }

    var billingCountry = document.getElementById('frm-billing_country').value;
    var billingState = document.getElementById('frm-billing_state').value;

    var billingCountries = JSON.parse(window.country_names);

    if (billingCountries[billingCountry] === undefined) {
      confirmation(null, 'Sorry, we only ship to US, CA and GB addresses at this time.');
      target.checked = false;
    } else {
      if (SC.utils.shippingHasAPOBoxAddress($('#frm-billing_address_1'), $('#frm-billing_address_2'))) {
        target.checked = false;
        return;
      }
      // copy billing address to shipping address
      document.getElementById('frm-shipping_first_name').value = document.getElementById('frm-billing_first_name').value;
      document.getElementById('frm-shipping_last_name').value = document.getElementById('frm-billing_last_name').value;
      document.getElementById('frm-shipping_country').value = billingCountry;
      document.getElementById('frm-shipping_address_1').value = document.getElementById('frm-billing_address_1').value;
      document.getElementById('frm-shipping_address_2').value = document.getElementById('frm-billing_address_2').value;
      document.getElementById('frm-shipping_city').value = document.getElementById('frm-billing_city').value;
      document.getElementById('frm-shipping_zip').value = document.getElementById('frm-billing_zip').value;

      // update shipping state based on billing country and state
      var shippingCountryContainer = document.querySelector('.shipping-address-container');
      var targetOption = shippingCountryContainer.querySelector('[data-value="' + billingCountry + '"]');
      updateStateOptions(targetOption);
      var targetStateOption = shippingCountryContainer.querySelector('[data-group="shipping_state"]');
      document.getElementById('frm-shipping_state').value = billingState;
      handleOptionChange(targetStateOption, billingState);
    }
  }

  /**
   * Sets the new value attribute on an select input
   *
   *
   * @param {object} target input dom node (object) to update
   * @param {string} newTargetOption (string) value to update
   * @returns {void}
   */
  function handleOptionChange(target, newTargetOption) {
    // traverse up one parent to get to the wrapper and get the previous siblings for the default button & select
    var optionsWrapper = target.parentNode;
    var defaultPlaceholder = optionsWrapper.children[0];
    var defaultButton = optionsWrapper.previousElementSibling;
    var select = defaultButton.previousElementSibling;

    // set the default button's text and the default placeholder's text to the select option text and close it
    defaultButton.innerHTML = newTargetOption;
    defaultPlaceholder.innerHTML = newTargetOption;

    // set the selected value on the original select
    var originalOption = select.querySelector('option[value="' + newTargetOption + '"]');
    originalOption.selected = true;
  }

  async function handleCardClick(event) {
    const profileId = event.currentTarget.dataset.creditCardId;

    if (!profileId) {
      return;
    }

    try {
      SC.utils.ui.toggleThrobber(true);

      // Fetch riders payment profile data
      const response = await fetch(`/profile/payments/${profileId.trim()}/`);

      SC.utils.ui.toggleThrobber(false);

      if (!response.ok || response.status !== 200) {
        confirmation(false, 'Error loading payment profile.');
        return;
      }

      const data = await response.json();
      // Track which existing card is being replaced so the backend can delete it
      const profileToEditInput = paymentForm.querySelector('#payment-profile-to-edit');

      if (profileToEditInput) {
        profileToEditInput.value = profileId;
      }

      // Update billing address details
      const addressFields = [
        'billing_first_name',
        'billing_last_name',
        'billing_address_1',
        'billing_address_2',
        'billing_city',
        'billing_state',
        'billing_zip',
      ];
      addressFields.forEach(field => {
        const input = paymentForm.querySelector(`[name="${field}"]`);

        if (input) {
          input.value = data[field] ?? '';
        }
      });

      // Update checkbox state
      const saveCcInput = paymentForm.querySelector('[name="set_default_payment_method"]');

      if (saveCcInput) {
          saveCcInput.checked = !!data.is_default;
      }

      formOpenedFromManageCards = true;
      showPaymentForm();
    } catch {
      SC.utils.ui.toggleThrobber(false);
      confirmation(false, 'Error loading payment profile.');
    }
  }

  /**
   *
   * Returns `true` if the Adyen secured fields are rendered.
   *
   * @return {boolean} adyen active
   */
  function isAdyenActive() {
    return $('[data-cse=encryptedCardNumber]').length > 0;
  }

  init();
  return {
    init: function () {
      // Initialize this manually when we load in via ajax
      // first load the lazies
      SC.loadLazyImages();
      // run the initialization
      init();
    }
  };
})();
